import api from 'networkapp-api-connector';

export default {
    favoriteSession: function (eventId, sessionId, favorited = true) {
        app.store.dispatch(app.actions.program.updateProgramItem(eventId, sessionId, { is_favorite: favorited }));
        return (
            api.program
                .favoriteSession(sessionId, favorited)
                // handle error
                .catch(() => app.store.dispatch(app.actions.program.updateProgramItem(eventId, sessionId, { is_favorite: !favorited })))
        );
    },
};
